import { render, staticRenderFns } from "./AssociateDashboard.vue?vue&type=template&id=00198175&scoped=true"
import script from "./AssociateDashboard.vue?vue&type=script&lang=js"
export * from "./AssociateDashboard.vue?vue&type=script&lang=js"
import style0 from "./AssociateDashboard.vue?vue&type=style&index=0&id=00198175&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00198175",
  null
  
)

export default component.exports